// Hide Recharge on International, and select the non-subscription option
hideRecharge();

function hideRecharge() {
	// Select the node that will be observed for mutations
	const targetNode = document.body;
	// Options for the observer (which mutations to observe)
	const config = { childList: true, subtree: true };
	// Callback function to execute when mutations are observed
	const callback = function (mutationsList, observer) {
		for (const mutation of mutationsList) {
			if (mutation.type === "childList" && mutation.addedNodes.length) {
				const rcWidget = document.querySelector(".rc-widget");
				if (rcWidget) {
					rcWidget.closest(".recharge-subscription-widget").classList.add("hidden");
					const nonSubscriptionOption = document.querySelector('.rc-radio__input[value="onetime"]');
					if (nonSubscriptionOption) {
						nonSubscriptionOption.click();
					}
					observer.disconnect();
				}
			}
		}
	};
	// Create an observer instance linked to the callback function
	const observer = new MutationObserver(callback);
	// Start observing the target node for configured mutations
	observer.observe(targetNode, config);
}